export const authCodeVerificationKey = 'GOTO_CODE_VERIFICATION'
export const refreshTokenCounterKey = 'shell-69582fdb-c693-42cb-98a4-c1d36894d2f9'
